import React from 'react'

export default function StatusHistory() {
    return (
        <div>
            StatusHistory
        </div>
    )
}
